import { axiosInstance } from './config/instance'
import { CONSOLE_API_URL, SERVER } from './config/url'

const DOCUMENTS_URL = `${SERVER}/${CONSOLE_API_URL}`
const ENTITY = 'documents'

export const documents = Object.freeze({
  async fetchList(data) {
    const response = await axiosInstance.post(`${DOCUMENTS_URL}/${ENTITY}/search`, data)
    return response.data
  },
  async fetchItem(id) {
    const response = await axiosInstance.get(`${DOCUMENTS_URL}/${ENTITY}/${id}`)
    return response.data
  },
  async createItem(data) {
    const response = await axiosInstance.post(`${DOCUMENTS_URL}/${ENTITY}`, data)
    return response.data
  },
  async updateItem(data) {
    const response = await axiosInstance.patch(`${DOCUMENTS_URL}/${ENTITY}`, data)
    return response.data
  },
  async deleteItem(id) {
    const response = await axiosInstance.delete(`${DOCUMENTS_URL}/${ENTITY}/${id}`)
    return response.data
  },
})
